(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lowkratief-crew"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-crew-copy]');
    if (!button) return;
    const code = button.dataset.crewCopy;
    const label = button.querySelector('span');
    const original = label.textContent;
    try {
      await navigator.clipboard.writeText(code);
      label.textContent = button.dataset.copySuccess;
      window.setTimeout(() => { label.textContent = original; }, 1800);
    } catch (error) {
      const input = document.createElement('textarea');
      input.value = code;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      input.remove();
      label.textContent = button.dataset.copySuccess;
      window.setTimeout(() => { label.textContent = original; }, 1800);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lowkratief-sparbundle-showcase"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.lk-bundle-showcase').forEach(function(section) {
    var track = section.querySelector('[data-lk-bundle-track]');
    var previous = section.querySelector('[data-lk-bundle-prev]');
    var next = section.querySelector('[data-lk-bundle-next]');
    if (!track || !previous || !next) return;

    function move(direction) {
      var card = track.querySelector('.lk-bundle-card');
      var distance = card ? card.getBoundingClientRect().width + 18 : track.clientWidth * 0.8;
      track.scrollBy({ left: distance * direction, behavior: 'smooth' });
    }

    previous.addEventListener('click', function() { move(-1); });
    next.addEventListener('click', function() { move(1); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
